import ReactGA from "react-ga4";

export const initGA = () => {
    ReactGA.initialize("G-GLT5EYKEHV"); // 👈 replace with your GA Measurement ID
};

export const logPageView = (path) => {
    ReactGA.send({ hitType: "pageview", page: path });
};
